export default __webpack_public_path__ + "static/media/ic-lose.1d161264.webp";